import { useState } from "react";
import { Urls } from "../../constants";
import { pushTo } from "../../store/history";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { selectMobileLayout } from "../../store/UIState";
import { SelectInput } from "../form/SelectInput";
import _ from "lodash";
import { ShowcaseImageToImageItem } from "./ShowcaseImageToImageItem";
import { HostedImgToImgModelNames, ImageToImageModels } from "../../constants/image-to-image-models";

const ModelNames = {
  ART_STYLE_TRANSFER: "Art style transfer",
  BACKGROUND_REMOVAL: "Background removal",
  OBJECT_ERASING: "Object erasing",
  IN_PAINTING: "In painting",
  IMAGE_UPSCALING: "Image upscaling",
  GROUNDING_DINO: "Grounding dino",
  INSTANTID: "InstantID",
  ESRGAN: 'ESRGAN'
}

const getTabName = (path) => {
  switch (path) {
    case Urls.MARKETING_AI_SHOWCASE_BACKGROUND_REMOVAL:
      return ModelNames.BACKGROUND_REMOVAL;
    case Urls.MARKETING_AI_SHOWCASE_OBJECT_ERASING:
      return ModelNames.OBJECT_ERASING;
    case Urls.MARKETING_AI_SHOWCASE_IN_PAINTING:
      return ModelNames.IN_PAINTING;
    case Urls.MARKETING_AI_SHOWCASE_IMAGE_UPSCALING:
      return ModelNames.IMAGE_UPSCALING;
    default:
      return ModelNames.ART_STYLE_TRANSFER;
  }
}

const selector = createSelector(
  (state) => selectMobileLayout(state),
  (isMobile) => ({ isMobile }
  ));

export const ShowcaseImageToImage = ({ showcase, match, mName, className }) => {
  const { isMobile } = useSelector(selector);

  const models = mName ? HostedImgToImgModelNames : showcase.models;

  const [currentTab, setCurrentTab] = useState(getCurrentTab(mName, match));

  const currentModel = getCurrentModel(mName, models, currentTab);

  const currentModelData = _.find(ImageToImageModels, model => model.label === currentTab);

  const onTabChanged = (model) => {
    if (!mName) {
      switch (model.name) {
        case ModelNames.BACKGROUND_REMOVAL:
          pushTo(Urls.MARKETING_AI_SHOWCASE_BACKGROUND_REMOVAL)
          break;
        case ModelNames.OBJECT_ERASING:
          pushTo(Urls.MARKETING_AI_SHOWCASE_OBJECT_ERASING)
          break;
        case ModelNames.IN_PAINTING:
          pushTo(Urls.MARKETING_AI_SHOWCASE_IN_PAINTING)
          break;
        case ModelNames.IMAGE_UPSCALING:
          pushTo(Urls.MARKETING_AI_SHOWCASE_IMAGE_UPSCALING)
          break;
        default:
          pushTo(Urls.MARKETING_AI_SHOWCASE_ART_STYLE_TRANSFER)
          break;
      }
    }
    setCurrentTab(model.name)
  }

  return (
    <div className={"ShowcaseImageToImage"}>

      <div className={"ShowcaseImageToImage__SelectLabel"}>
        {getModelName(mName)}
      </div>

      {mName !== 'esrgan' && mName !== 'grounding-dino' && mName !== 'instant-id' &&
        <SelectInput
          className={"ShowcaseImageToImage__MobileTabs"}
          value={{ label: currentTab, value: currentTab }}
          options={_.map(models, (model, index) =>
            ({ label: model.name, value: model.name }))}
          onChange={(option) => onTabChanged(_.find(models, model =>
            model.name === option.value))}
        />}


      {(currentTab === ModelNames.ART_STYLE_TRANSFER ||
        currentTab === ModelNames.BACKGROUND_REMOVAL ||
        currentTab === ModelNames.OBJECT_ERASING ||
        currentTab === ModelNames.IN_PAINTING ||
        currentTab === ModelNames.IMAGE_UPSCALING ||
        currentTab === ModelNames.GROUNDING_DINO ||
        currentTab === ModelNames.INSTANTID ||
        currentTab === ModelNames.ESRGAN
      )
        && <ShowcaseImageToImageItem model={currentModel} modelData={currentModelData}
          className={className} mName={mName} />}
    </div>
  )
}

function getCurrentTab(mName, match) {
  if (!mName) return getTabName(match ? match.url : '');
  switch (mName) {
    case 'instant-id':
      return ModelNames.INSTANTID;
    case 'grounding-dino':
      return ModelNames.GROUNDING_DINO;
    case 'esrgan':
      return ModelNames.ESRGAN;
    default:
      return ModelNames.ART_STYLE_TRANSFER
  }
}

function getCurrentModel(mName, models, currentTab) {
  switch (mName) {
    case 'grounding-dino':
      return { name: 'Grounding Dino' };
    case 'instant-id':
      return { name: 'InstantID' };
    case 'esrgan':
      return { name: 'ESRGAN' }
    default:
      return _.find(models, model => (model.name === currentTab));
  }
}

function getModelName(mName) {
  switch (mName) {
    case 'instant-id':
      return 'InstantX / InstantID Model';
    case 'grounding-dino':
      return 'Grouding Dino Model';
    case 'esrgan':
      return 'ESRGAN Model';
    default:
      return 'Image transformation AI model';
  }
}